define('shared/initializer/form/adapters/Base',['$', 'shared/lib/RSVP', 'shared/lib/Mixer', 'shared/lib/Emitter'], function ( $, RSVP, Mixer, emitter ) {
    'use strict';

    function Items() { }

    Items.prototype.set = function ( name, obj ) {
        var me = this;
        var container;

        name = name.toLowerCase();

        if ( me[name] == null ) {
            me[name] = {};
        }

        container = me[name];

        for( var key in obj ) {
            if ( !obj.hasOwnProperty( key ) ) {
                continue;
            }

            container[key] = obj[key];
        }
    };

    Items.prototype.get = function ( name ) {
        var me = this;
        name = name.toLowerCase();
        return me[name];
    };

    function resolveAsIs( data ) {
        return RSVP.resolve(data);
    }

    function Ctor( $form, type, options ) {
        var me = this;

        if ( $form == null || $form.length <= 0 ) {
            throw new Error('Form element is not specified.');
        }

        me.options = options || {};
        me.type = type;
        // jQuery obj which refs to form element
        me.$form = $form;
        // all UI fields
        me.items = new Items();
        me.lifeCycles = [
            'doPageLoad', 
            'doAfterPageLoad', 
            'doBeforeValidation', 
            'doValidationFail', 
            'doBeforeSubmit', 
            'doSubmit', 
            'doAfterSubmit', 
            'doSubmitFail',
            'doError'
        ];
        emitter(me);
    }

    var p = Ctor.prototype;

    p.mixin = function(){
        var mixer = new Mixer(this, [this.$form, this.type, this.options], this.lifeCycles);
        mixer.mix.apply(mixer, arguments);
        mixer.dispose();
    };

    p.doPageLoad = resolveAsIs;

    p.doAfterPageLoad = resolveAsIs;

    p.doBeforeSubmit = resolveAsIs;

    p.doSubmit = resolveAsIs;

    p.doAfterSubmit = resolveAsIs;

    p.doSubmitFail = resolveAsIs;

    p.doError = resolveAsIs;

    return Ctor;
});
